import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { BankAccountService } from '../../services/bank-account.service';
import {
  BankAccountActionTypes,
  LoadBankAccounts,
  LoadBankAccountsFailure,
  LoadBankAccountsSuccess
} from '../actions/bank-account.actions';
import { SummaryBankAccountModel } from '../../models/summary-bank-account.model';

@Injectable()
export class BankAccountEffects {
  constructor(private actions$: Actions, private service: BankAccountService) {}

  loadBankAccount$ = createEffect(() => this.actions$.pipe(
    ofType(BankAccountActionTypes.LoadBankAccounts),
    mergeMap((action: LoadBankAccounts) =>
      this.service.getSummaryList(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryBankAccountModel>) => {
          if (!res || !res.isSuccess) {
            return new LoadBankAccountsFailure({ error: 'No se pudo cargar la lista de cuentas bancarias' });
          }
          return new LoadBankAccountsSuccess({ items: res.values, total: res.total });
        }),
        catchError(error => of(new LoadBankAccountsFailure({ error })))
      )
    )
  ));
}
